import { type ReactNode } from "react";

interface Prop_CTL_GroupLabel{
  className?:string;
  label?:string;
  children?:ReactNode;
}

export function CTL_GroupLabel( props:Prop_CTL_GroupLabel ){
  
  return (
    <div className="flex flex-col">
      {props.label&&props.label!=''?<div className="text-zinc-400 text-[.9rem]">{props.label}</div>:null}
      <div className="flex-1 w-full">{props.children}</div>
    </div>)
}
